import React from "react";
import { Container, Divider, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CategoryItem } from "../../../components/CategoryItem";
import { useGetCategorySectionProps } from "../../../containers/CategoryContainer/CategoryContainer";

/** Career part to invite people to actually use the platform as host or cohost (copy of the home page pretty much) */
export const CareerMembersPage = () => {
    const { t } = useTranslation();
    //all data comes from the locales
    const host = useGetCategorySectionProps('host', true)
    const cohost = useGetCategorySectionProps('cohost', true)

    const renderCategorySection = (categories: ReturnType<typeof useGetCategorySectionProps>) => {
        return (
            <Stack sx={{ px: 2 }} direction={'column'}>
                <Typography fontWeight={'bold'} variant={'h4'}>{categories.title}</Typography>
                <Typography variant={'subtitle2'} sx={{ py: 1 }}>{categories.description}</Typography>
                <Grid container spacing={2} justifyContent={'center'}>
                    {categories.categories
                        .map((category, index) => (
                            !!index && //bypass the first option
                            <Grid key={index} item xs={12} sm={6} md={4}>
                                <CategoryItem
                                    key={index}
                                    imgSrc={category.image}
                                    title={category.title}
                                    description={category.description}
                                    onClick={category.onClick}
                                />
                            </Grid>
                        ))}
                </Grid>
            </Stack>
        );
    }
    return (
        <Container sx={{ p: 2 }}>
            <Stack direction={'column'} sx={{ mb: 2 }} spacing={1}>
                <Typography variant="h2" fontWeight={"bold"}>{t('careers.members.title')}</Typography>
                <Typography>{t('careers.members.content')}</Typography>
                <Stack direction={'column'} spacing={2}>
                    {renderCategorySection(host)}
                    <Divider />
                    {renderCategorySection(cohost)}
                </Stack>
            </Stack>
        </Container>
    );
};
